import gql from 'graphql-tag';

export const WorkspaceThemePreferenceQuery = gql`
	query WorkspaceThemePreferenceQuery($workspaceAri: ID!, $accountId: ID!) {
		settings_userPreferencesResolved(workspaceAri: $workspaceAri, accountId: $accountId) {
			theme
		}
	}
`;
